import * as React from "react";
import type { SVGProps } from "react";
const SvgPinterestNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M10.503 2.5c-3.094 0-6.128 2.043-6.128 5.377 0 2.103 1.172 3.305 1.893 3.305.3 0 .48-.811.48-1.052 0-.27-.72-.87-.72-2.042 0-2.404 1.832-4.116 4.205-4.116 2.073 0 3.575 1.172 3.575 3.305 0 1.592-.63 4.566-2.704 4.566-.75 0-1.412-.54-1.412-1.292 0-1.142.811-2.253.811-3.425 0-1.982-2.823-1.622-2.823.781 0 .511.06 1.052.3 1.533-.42 1.772-1.262 4.446-1.262 6.278 0 .57.06 1.112.12 1.683.09.12.06.12.21.06 1.503-2.073 1.473-2.494 2.134-5.198.39.691 1.321 1.082 2.102 1.082 3.185 0 4.627-3.124 4.627-5.918 0-2.974-2.584-4.927-5.408-4.927"
    />
  </svg>
);
export default SvgPinterestNegative;
